import { httpClient } from '@/infrastructure/http/client/httpClient';
import type { PanelContactHistoryItem } from '@/presentation/components/collections/ContactDebtorModal';

export type LastContactMap = Record<string, PanelContactHistoryItem>;

export async function fetchLatestContacts(tenantIds: string[]): Promise<LastContactMap> {
  const ids = [...new Set(tenantIds.filter(Boolean))];
  if (ids.length === 0) return {};
  try {
    const res = await httpClient.get<{ items: LastContactMap }>(
      `/collections/contact-latest?tenantIds=${encodeURIComponent(ids.join(','))}`
    );
    return res.data.items || {};
  } catch {
    return {};
  }
}

export const CONTACT_STATUS_COLORS: Record<string, string> = {
  pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
  sent: 'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-200',
  delivered: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  read: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300',
  opened: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300',
  clicked: 'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-300',
  failed: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  bounced: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300',
  dropped: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
};
